import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {useSelector} from "react-redux";
import {useDispatch} from "react-redux";
import {updateProfileInfo} from './endpoints/action';
import {profileSelector} from "./endpoints/selector";
import { 
  setInitalState
} from "./endpoints/slice";
import Error from '../common/Message/error';
import Success from "../common/Message/success";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import './form.css';
import { useNavigate } from "react-router-dom";

export default (props) => {
    const userDetailsList = props.userDetailsList;
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');

    const [errors, setErrors] = useState([]);
    const [userType, setUserType] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [cellNumber, setCellNumber] = useState('');
    const [workNumber, setWorkNumber] = useState('');
    const [employerUserId, setEmployerUserId] = useState('');

    const navigate = useNavigate();

    const {successMessage, errorMessage} = useSelector(profileSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if(login.employerUserId) {
            if(login.userType === 1) {
                setUserType("Super Duper User");
            } else if(login.userType === 2) {
                setUserType("Super User");
            } else {
                setUserType("User");
            }
        }
    }, [login]);

    useEffect(() => {
            setFirstName(userDetailsList.firstName);
            setLastName(userDetailsList.lastName);
            setCellNumber(userDetailsList.cellPhoneNumber);
            setWorkNumber(userDetailsList.workNumber);
            setEmail(userDetailsList.email);
            setEmployerUserId(userDetailsList.employerUserId);
            setEmployeeId(userDetailsList.employeeId);
            setErrors([]);
            dispatch(setInitalState());
    }, [userDetailsList]);

    const validateEmpID = (key, value) => {
      value = ChkEmploeeID(value);
      if(key === 'employeeId')
      setEmployeeId(value);
      else {
        setEmployeeId(value);
      }
    }

    const ChkEmploeeID = (value) => {
      if (!value) return value;
      const ChkEmploeeValue = value;
      const ChkEmploeeValueLength = ChkEmploeeValue.length;
      if (ChkEmploeeValueLength <= 3) 
      {
        return ChkEmploeeValue;
      }
      else
      {
       return `${ChkEmploeeValue.slice(0, 3)}`;
      }
        }

    const formatPhoneNumber = (value) => {
      if (!value) return value;
      const phoneNumber = value.replace(/[^\d]/g, '');
      const phoneNumberLength = phoneNumber.length;
      if (phoneNumberLength < 4) return phoneNumber;
      if (phoneNumberLength < 7) {
          return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
      }
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
          3,
          6
      )}-${phoneNumber.slice(6, 10)}`;
    }
    
    const validatePhoneNumber = (key, value) => {
      value = formatPhoneNumber(value);
      if(key === 'cellNumber')
        setCellNumber(value);
      else {
        setWorkNumber(value);
      }
    }

      const validateForm = () => {
        const newErrors = {};
        const phoneno = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
        if(!firstName || firstName === '') newErrors.firstName = "Please enter the First Name"
        if(!lastName || lastName === '') newErrors.lastName = "Please enter the Last Name"
        if(!email || email === '') newErrors.email = "Please enter the Email"
        if(!cellNumber || cellNumber === '') {
          newErrors.cellNumber = "Please enter the Phone number"
        } else if(!cellNumber.match(phoneno)) {
          newErrors.cellNumber = "Phone number should be a 10 digit number"
        }
        if(!workNumber || workNumber === '') {
          newErrors.workNumber = "Please enter the Phone number"
        } else if(!workNumber.match(phoneno)) {
          newErrors.workNumber = "Phone number should be a 10 digit number"
        }
        if(!employeeId || employeeId === '') newErrors.employeeId = "Please enter the Employee Id"
        return newErrors
      }

      const validateAndSubmit = (e) => {
        e.preventDefault();
    
        const formErrors = validateForm();
        if(Object.keys(formErrors).length > 0) {
          setErrors(formErrors);
        } else {
          setErrors([]);
          dispatch(updateProfileInfo(config.baseUrl, {
            employerUserId: login.employerUserId,
            employerId: login.employerId,
            userType: login.userType,
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: "string",
            cellPhoneNumber: cellNumber,
            workNumber: workNumber,
            employeeId: employeeId,
            createdBy: 0,
            updatedBy: 0,
            locationId: 0,
            isApprovalUser: login.accountFlags.isApprovalUser,
            isContact: true,
            appUserId: login.appUserId
          }));
        }
    }

    function cancel() {
      navigate('/openshifts')
    }
    
    return (
        <>
        {
          errorMessage && <Error errorMessage={errorMessage}/>
        }
        {
          successMessage && <Success successMessage={successMessage} />
        }
        <div >
          <div >
            <div  id="tab25">
              <div class="col-xl-12" id="profileForm">
                  <Form autoComplete="off" noValidate onSubmit={validateAndSubmit}>
                      <Row>
                        <Form.Group as={Col} className="md-6" controlId="firstName">
                          <Form.Label>First Name*</Form.Label>
                          <Form.Control type="text" 
                            value={firstName}
                            onChange={e => {
                                setFirstName(e.currentTarget.value)
                            }}
                            placeholder="First Name" 
                            isInvalid={!!errors.firstName}/>
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} className="md-6" controlId="lastName">
                          <Form.Label>Last Name*</Form.Label>
                          <Form.Control type="text" 
                            value={lastName}
                            onChange={e => {
                              setLastName(e.currentTarget.value)
                            }}
                            placeholder="Last Name" 
                            isInvalid={!!errors.lastName}/>
                          <Form.Control.Feedback type="invalid">
                            {errors.lastName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                     
                      <Row>
                        <Form.Group as={Col} className="md-6" controlId="email">
                          <Form.Label>Email*</Form.Label>
                          <Form.Control type="text" 
                            value={email}
                            onChange={e => {
                              setEmail(e.currentTarget.value)
                            }}
                            placeholder="Email" 
                            isInvalid={!!errors.email} />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} className="md-6" controlId="city">
                          <Form.Label>User Type</Form.Label>
                          <Form.Text>{userType}</Form.Text>
                        </Form.Group>
                      </Row>
                     
                      <Row>
                        <Form.Group as={Col} className="md-6" controlId="employeeId">
                          <Form.Label >Employee ID*</Form.Label>
                          <Form.Control type="text" 
                            value={employeeId}
                            onChange={e => {
                              validateEmpID('employeeId', e.currentTarget.value)
                             // setEmployeeId(e.currentTarget.value)
                            }}
                            placeholder="Employee ID" 
                            isInvalid={!!errors.employeeId} />
                          <Form.Control.Feedback type="invalid">
                            {errors.employeeId}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} className="md-6" controlId="cellNumber">
                          <Form.Label>Cell #*</Form.Label>
                          <Form.Control type="text" 
                            value={cellNumber}
                            onChange={e => {
                              validatePhoneNumber('cellNumber', e.currentTarget.value)
                            }}
                            placeholder="Cell Phone" 
                            isInvalid={!!errors.cellNumber} />
                          <Form.Control.Feedback type="invalid">
                            {errors.cellNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      
                      <Row className="w-50">
                        <Form.Group as={Col} className="md-12" controlId="workNumber">
                          <Form.Label>Work #*</Form.Label>
                          <Form.Control type="text" 
                            value={workNumber}
                            onChange={e => {
                              validatePhoneNumber('workNumber', e.currentTarget.value)
                            }}
                            placeholder="Work Phone" 
                            isInvalid={!!errors.workNumber} />
                          <Form.Control.Feedback type="invalid">
                            {errors.workNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      <div class="card-footer text-end formButton">
                        <Button class="btn btn-success my-1" type="Submit">
                          Save
                        </Button>
                        <button class="btn btn-outline-primary my-1" type="Submit" onClick={cancel} >
                          Cancel
                        </button>
                      </div>
                    </Form>
              </div>
            </div>
          </div>
        </div>
        </>
      );
}